import { APP_TYPE } from 'shared/config'
import { GlobalLightEvents } from 'app/shared/ui/GlobalEvents'

export const CommonLightLayout = () => {
  const isVueApp = APP_TYPE === 'vue'

  return <>{!isVueApp && <GlobalLightEvents />}</>
}
